/* eslint-disable arrow-parens */
import { useState, useContext, useEffect, useCallback, Suspense } from "react";
import DashBoardGroupGrid from "./dashBoardGroupGrid/DashBoardGroupGrid";
import { api } from "../../../../utils/api";
import { ADMIN_DASHBOARD_HEADER } from "../../../../constants/caption/dashboardHeader";
import { UIContext } from "../../../../contexts";

import "date-fns";
import DateFnsUtils from "@date-io/date-fns";

import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import { Tab, Box, Tabs, Typography } from "@material-ui/core";
import PropTypes from "prop-types";

import EventIcon from "@material-ui/icons/Event";

import "./dashBoard.css";

// const current = new Date();
// const currentDate = `${current.getDate() - 1}/${current.getMonth() + 1}/${current.getFullYear()}`;
const date = new Date();
const maxDateRange = date.setDate(date.getDate() - 1);

// eslint-disable-next-line arrow-parens
// eslint-disable-next-line arrow-parens
const TabPanel = (props) => {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box sx={{ p: 3 }}>
					<Typography>{children}</Typography>
				</Box>
			)}
		</div>
	);
};

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.number.isRequired,
	value: PropTypes.number.isRequired
};

// eslint-disable-next-line prettier/prettier
// eslint-disable-next-line arrow-parens
const a11yProps = (index) => {
	return {
		id: `simple-tab-${index}`,
		"aria-controls": `simple-tabpanel-${index}`
	};
};

const DashBoard = () => {
	const [groups, setGroups] = useState([]);
	const [value, setValue] = useState(0);
	const [dateRange, setDateRange] = useState({
		start_date: "",
		end_date: ""
	});
	const [dateRangeForm, setDateRangeForm] = useState([]);

	const { setDashboardHeader } = useContext(UIContext);

	const getStaticGroups = useCallback(() => {
		const _groups = [
			{
				name: "Dallas Wholesale ",
				group_number: "109"
			},
			{
				name: "Brookshier Brothers, Inc.",
				group_number: "220"
			},
			{
				name: "JP Morgan",
				group_number: "198"
			}
		];
		setGroups(Object.assign([], _groups));
	}, []);

	// const getGroups = useCallback(async () => {
	// 	const _groups = await api.group.getGroups();
	// 	console.log("Groups", _groups);
	// 	setGroups(Object.assign([], _groups));
	// }, []);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	const handleDateChange = useCallback(
		(_date, name) => {
			const date = new Date(_date);
			const parsedDate = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
			setDateRange(Object.assign({}, dateRange, { [name]: parsedDate }));
			if (name === "end_date" && dateRange.start_date !== "") {
				let d1 = new Date(dateRange.start_date);
				let d2 = new Date(parsedDate);

				if (d1 > d2) {
					alert("To Date should be greater than from date");
					setDateRange(Object.assign({}, dateRange, { end_date: "" }));
				}
			} else if (name === "start_date" && dateRange.end_date !== "") {
				let d1 = new Date(dateRange.end_date);
				let d2 = new Date(parsedDate);

				if (d1 < d2) {
					alert("To Date should be greater than from date");
					setDateRange(Object.assign({}, dateRange, { start_date: "" }));
				}
			}
		},
		[dateRange]
	);

	useEffect(() => {
		getStaticGroups();
	}, [getStaticGroups]);

	useEffect(() => {
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.dashBoard);
	}, [setDashboardHeader]);

	useEffect(() => {
		setDateRangeForm(
			Object.assign(
				[],
				[
					{
						name: "start_date",
						label: "From",
						placeholder: "Enter Start Date",
						value: dateRange.start_date,
						onChange: (date, name) => handleDateChange(date, name)
					},
					{
						name: "end_date",
						label: "To",
						placeholder: "Enter End Date",
						value: dateRange.end_date,
						onChange: (date, name) => handleDateChange(date, name)
					}
				]
			)
		);
	}, [dateRange.end_date, dateRange.start_date, handleDateChange]);

	return (
		<div className="dashboard-group-tab">
			<Tabs
				value={value}
				onChange={handleChange}
				variant="scrollable"
				scrollButtons="auto"
				aria-label={"scrollable auto tabs example"}
				TabIndicatorProps={{
					style: {
						border: "none",
						backgroundColor: "#558b2f"
					}
				}}
				className="glb-tab-panel"
			>
				{groups.map((group, index) => {
					const { name, group_number } = group;
					return (
						<Tab
							label={`Group ${group_number} - ${name}`}
							className="glb-tab-label"
							key={index}
							{...a11yProps(index)}
						/>
					);
				})}
			</Tabs>
			<div className="date-viewer-container">
				{dateRangeForm.map((eachDate, index) => {
					return (
						<MuiPickersUtilsProvider utils={DateFnsUtils} key={index}>
							<KeyboardDatePicker
								className="from-date-input date-input"
								id="from-date-input"
								inputVariant="outlined"
								label={eachDate.label}
								placeholder={eachDate.placeholder}
								name={eachDate.name}
								format="MM/dd/yyyy"
								error={false}
								value={eachDate.value}
								maxDate={maxDateRange}
								onChange={(date) => eachDate.onChange(date, eachDate.name)}
								InputProps={{
									readOnly: true
								}}
								InputLabelProps={{
									shrink: true
								}}
								//style={{ width: "340px", borderRadius: 50 }}
								keyboardIcon={<EventIcon style={{ color: "#7cb342" }} />}
								KeyboardButtonProps={{
									"aria-label": "change date"
								}}
								// disabled={!isButtonSelected}
								// disableElevation={!isButtonSelected}
								style={{
									// cursor: !isButtonSelected ? "not-allowed" : "pointer",
									pointerEvents: "unset",
									width: "340px",
									borderRadius: 50
								}}
								helperText={""}
							/>
						</MuiPickersUtilsProvider>
					);
				})}
			</div>
			{groups.map((group, index) => {
				const { group_number } = group;
				return (
					<TabPanel value={value} key={index} index={index}>
						<DashBoardGroupGrid />
					</TabPanel>
				);
			})}
		</div>

		// <div>
		// 	{groups.map((group, index) => {
		// 		return <div key={index}>{group.name}</div>;
		// 	})}
		// </div>
	);
};

export default DashBoard;
